import React, { FC, ChangeEvent } from 'react'
import { Modal, Button, Form, Alert } from 'react-bootstrap'
import { ContentItem } from '../core/_models'

type MoveAction = 'before' | 'after'

interface MoveChapterFormValues {
  sourceChapterId: string
  action: MoveAction
  targetChapterId: string
}

interface ModalMoveChapterProps {
  show: boolean
  onHide: () => void
  onSubmit: () => void
  onDataChange: (e: ChangeEvent<HTMLSelectElement>) => void
  values: MoveChapterFormValues
  chapters: ContentItem[]
  isLoading: boolean
  error?: string | null
}

const ModalMoveChapter: FC<ModalMoveChapterProps> = ({
  show,
  onHide,
  onSubmit,
  onDataChange,
  values,
  chapters,
  isLoading,
  error,
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Move Article</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}

        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Article to move</Form.Label>
            <Form.Select
              name="sourceChapterId"
              value={values.sourceChapterId}
              onChange={onDataChange}
            >
              <option value="">-- Select article --</option>
              {chapters.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.chapter_name || '-'}/{c.chapter_number || '-'} ({c.chapter_id || '-'}) —{' '}
                  {c.article_name || '-'}/{c.article_number || '-'} ({c.article_id || '-'})
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Move position</Form.Label>
            <Form.Select
              name="action"
              value={values.action}
              onChange={onDataChange}
            >
              <option value="before">Before</option>
              <option value="after">After</option>
            </Form.Select>
          </Form.Group>

          <Form.Group>
            <Form.Label>Target Article</Form.Label>
            <Form.Select
              name="targetChapterId"
              value={values.targetChapterId}
              onChange={onDataChange}
            >
              <option value="">-- Select article --</option>
              {chapters.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.chapter_name || '-'}/{c.chapter_number || '-'} ({c.chapter_id || '-'}) —{' '}
                  {c.article_name || '-'}/{c.article_number || '-'} ({c.article_id || '-'})
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="default" className="btn-cancel" onClick={onHide}>
          Cancel
        </Button>

        <Button
          type="button" // IMPORTANT so it actually works
          variant="primary"
          onClick={onSubmit}
          disabled={
            isLoading ||
            !values.sourceChapterId ||
            !values.targetChapterId ||
            values.sourceChapterId === values.targetChapterId
          }
        >
          Move
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalMoveChapter
